<template lang="pug">
  #show-customer-info
    b-card(header-tag="header")
      show-customer-data(:sales_channel="sales_channel")
</template>

<script>
import ShowCustomerData from "@/components/supportSite/ShowCustomerData";

export default {
  name: "ShowCustomerInfo",
  components: {
    ShowCustomerData,
  },
  props: {
    sales_channel: { type: String, require: true }
  }
}
</script>

<style scoped>

</style>